import { defineComponent as n, createBlock as a, openBlock as t, unref as r, mergeProps as m, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconDiamond",
  __name: "IconDiamond",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const o = l;
    return (c, e) => (t(), a(r(d), m(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M10.09 3.874a1.25 1.25 0 0 0-.438.08L5.857 5.375a1.25 1.25 0 0 0-.51.357l-2.63 3.07a1.25 1.25 0 0 0 .02 1.649l8.334 9.26a1.25 1.25 0 0 0 1.858 0l8.335-9.26a1.25 1.25 0 0 0 .02-1.65l-2.624-3.06a1.25 1.25 0 0 0-.554-.373l-4.292-1.43a1.25 1.25 0 0 0-.395-.064h-3.328M7.72 6.28l2.417-.906h3.242l2.799.932-2.27.568h-3.815L7.72 6.28M5.915 7.376 4.507 9.019l4.079 1.631.96-2.367-3.631-.907M5.15 10.892l4.95 5.498-1.677-4.19-3.273-1.307m8.751 5.498 4.95-5.499-3.274 1.31-1.676 4.19m5.593-7.371-1.409-1.644-3.632.908.961 2.367 4.08-1.631m-8.366-.645h1.744a.8.8 0 0 0 .012.032l1.002 2.468h-3.772l1.002-2.468a.8.8 0 0 0 .012-.032m-1.02 4L12 17.104l1.892-4.73h-3.784",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
